import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=964b1ef8&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=964b1ef8&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b1ef8",
  null
  
)

export default component.exports